import Select from './select.vue'
import Option from './option.vue'
import OptionGroup from './option-group.vue'

export default (Vue) => {
  Vue.component(Select.name, Select)
  Vue.component(Option.name, Option)
  Vue.component(OptionGroup.name, OptionGroup)
}
